import { defineDocStore } from '@/stores/base/baseDocStore'
import { FilterMatchMode } from '@primevue/core/api'
import { type TransactionRecord } from '@/types/Transaction'
import { createTransaction } from '@/factories/transactionFactory'

// Define default filters and sort order
export const defaultFilters = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  transaction_number: { value: null, matchMode: FilterMatchMode.CONTAINS },
  transaction_date: { value: null, matchMode: FilterMatchMode.DATE_IS },
  transaction_type: { value: null, matchMode: FilterMatchMode.EQUALS },
  party_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  total_amount: { value: null, matchMode: FilterMatchMode.EQUALS },
  payment_status: { value: null, matchMode: FilterMatchMode.EQUALS },
  transaction_status: { value: null, matchMode: FilterMatchMode.EQUALS },
}

export const defaultSort = {
  field: 'transaction_date',
  order: -1,
}

// Create the transaction store using the base document store
export const useTransactionStore = defineDocStore<TransactionRecord>({
  entityName: 'transaction',
  collection: 'transaction_records',
  model: {
    create: (data?: Partial<TransactionRecord>) => createTransaction(data),
  },
  initialState: {
    filters: defaultFilters,
    sort: defaultSort,
  },
})

// Re-export types and factory for convenience
export type { TransactionRecord } from '@/types/Transaction'
export { createTransaction, createTransactionItem } from '@/factories/transactionFactory'
